export const startReloadPage = () => ({
  type: 'START_RELOAD_PAGE',
});

export const stopReloadPage = () => ({
  type: 'STOP_RELOAD_PAGE',
});
